import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DialogService } from '../modules/shared/services/dialog.service';

@Injectable({
  providedIn: 'root'
})
export class DataLoadingService {
    dataLoadingActive: BehaviorSubject<boolean>;
    currentLoadingCount = 0;
    currentLoadingUrls: string[] = [];
  
    constructor(private dlg: DialogService) {
        this.dataLoadingActive = new BehaviorSubject<boolean>(false);
    }
  
    startLoading(url: string) {
        this.currentLoadingCount++;
        this.checkBypassList(url);
        this.dataLoadingActive.next(this.currentLoadingUrls.length !== 0);
    }
  
    finishLoading(url: string) {
        this.currentLoadingCount--;
        this.updateLoadingList(url);
        this.dataLoadingActive.next(this.currentLoadingUrls.length !== 0);
    }
  
    private checkBypassList(url: string) {
        let bypass = false;
        this.bypassUrlList.forEach(itm => {
            if (url.indexOf(itm) > -1) {
                bypass = true;
            }
        });
    
        if (!bypass) {
            //Now check to see if it's already in the loading list
            let idx = this.currentLoadingUrls.indexOf(url);
            if (idx < 0) {
            //Only add to list if not already in the list
                this.currentLoadingUrls.push(url);
            }
        }
    }
  
    private updateLoadingList(url: string) {
        let idx = this.currentLoadingUrls.indexOf(url);
        if (idx > -1) {
            this.currentLoadingUrls.splice(idx, 1);
        }
    }
  
    bypassUrlList: string[] = ['company/create',
        'nominalMapping/external',
        'financialYear/processperiod',
        'financialYear/processEndOfYear',
        'transaction/latest'];
}
